import { RootState } from './../core/store';
import { Locale, widgetUrlSelector } from './userPreferences';
import { MessageFormatElement } from 'react-intl';
import { AppDispatch } from '../core/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

type Message = Record<string, string> | Record<string, MessageFormatElement[]> | undefined;

interface MessagesReducerState {
  messages?: Message;
}

const initialState: MessagesReducerState = {};

const i18nSlice = createSlice({
  name: 'i18nMessages',
  initialState,
  reducers: {
    setMessages: (state: MessagesReducerState, action: PayloadAction<Message>) => {
      state.messages = action.payload;
    },
  },
});

export default i18nSlice.reducer;
const { setMessages } = i18nSlice.actions;
export const messagesSelector = (state: RootState) => state.i18n.messages;

export const loadMessages = (locale: Locale) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const widgetUrl = widgetUrlSelector(getState());
  const { data: messages } = await axios.get(`${widgetUrl}i18n/${locale}.json`);
  dispatch(setMessages(messages));
};
